import routes from './routes';
import { SetRoutes } from 'components';

const InvoicesPiecesPages = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default InvoicesPiecesPages;
